import { AuthGroupEnum } from "domain/authorization";
import { Auth } from "aws-amplify";
import { useCallback, useEffect, useState } from "react";
import { useSyndicationLayout } from "./Syndication";

interface GroupValidation {
  isDeveloper?: boolean;
  isAdmin?: boolean;
  isInvestor?: boolean;
  isFundManager?: boolean;
  isSyndicationAdmin?: boolean;
  hasAdminLevel?: boolean;
  groups?: AuthGroupEnum[];
}

const existsInList = (list: string[], text: string) => list.indexOf(text) > -1;

const getCurrentSession = async () => {
  try {
    return await Auth.currentSession();
  } catch (e) {
    return undefined;
  }
};

export const useGroupValidation = () => {
  const syndicationLayout = useSyndicationLayout();
  const [loading, setLoading] = useState(true);
  const [groupValidation, setGroupValidation] = useState<GroupValidation>({});

  const populateGroupValidation = useCallback(async () => {
    const session = await getCurrentSession();
    const groups = session?.getIdToken()?.payload["cognito:groups"] || [];

    const isAdmin = existsInList(groups, AuthGroupEnum.Admin);
    const isDeveloper = existsInList(groups, AuthGroupEnum.Developer);

    const isSyndicationAdmin = !!(
      (syndicationLayout?.isSyndicate &&
        existsInList(
          groups,
          `syndication-${syndicationLayout.mainInfo.id}-admin-group`
        )) ||
      isAdmin
    );
    const isFundManager =
      isAdmin ||
      (!syndicationLayout.isSyndicate &&
        existsInList(groups, AuthGroupEnum.FundManager)) ||
      (syndicationLayout.isSyndicate &&
        existsInList(
          groups,
          `syndication-${syndicationLayout.mainInfo.id}-fund-manager-group`
        ));
    const isInvestor =
      isAdmin ||
      existsInList(groups, AuthGroupEnum.Investor) ||
      (syndicationLayout.isSyndicate &&
        existsInList(
          groups,
          `syndication-${syndicationLayout.mainInfo.id}-investor-group`
        ));

    const hasAdminLevel = isAdmin || isSyndicationAdmin;

    setGroupValidation({
      isAdmin,
      isFundManager,
      isInvestor,
      isSyndicationAdmin,
      groups,
      hasAdminLevel,
      isDeveloper,
    });
    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    populateGroupValidation();
  }, [populateGroupValidation]);

  return {
    ...groupValidation,
    loading,
  };
};
